import { useCallback } from 'react'
import { createSearchParams, useSearchParams } from 'react-router-dom'

export const useStickySearchParams = (stickyParams: string[]) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const setStickySearchParams: typeof setSearchParams = useCallback(
    (nextInit, options) => {
      setSearchParams((current) => {
        const _nextInit = typeof nextInit === 'function' ? nextInit(current) : nextInit
        const nextParams = createSearchParams(_nextInit)

        stickyParams.forEach((key) => {
          if (!nextParams.has(key) && current.has(key)) {
            nextParams.set(key, current.get(key)!)
          }
        })

        return nextParams
      }, options)
    },
    [setSearchParams, stickyParams],
  )

  return { searchParams, setSearchParams: setStickySearchParams }
}
